export function AddItemToSkuVault(input){
    return new Promise(async function(resolve,reject){
        let bagaz=input
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/AddItemToSkuVault', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                //console.log('sku returns',response)
                resolve(response)
            })
        })
    }

export function AddQuantityToSkuVault(input){
    return new Promise(async function(resolve,reject){
        let bagaz=input
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/AddQuantityToSkuVault', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                //console.log('sku returns',response)
                resolve(response)
            })
        })
    }
export function RemoveItemWhlsSkuVault(input){
    return new Promise(async function(resolve,reject){
        let bagaz=input
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/remove_quantity_from_whls_SkuVault', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                //console.log('sku returns',response)
                resolve(response)
            })
        })
    }
